import datapoints from '../datapoints';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { LOAD_MORE_INCREMENT, loadConversation } from 'owa-mail-store-actions';
import mailStore from 'owa-mail-store/lib/store/Store';
import { action, select } from 'satcheljs/lib/legacy';
export default action('loadMore', datapoints.RPCountLoadMore)(select({
    conversations: function () { return mailStore.conversations; },
})(function loadMore(conversationId, state) {
    if (conversationId && state.conversations.has(conversationId.Id)) {
        var conversationItemParts = state.conversations.get(conversationId.Id);
        conversationItemParts.isLoadMoreInProgress = true;
        conversationItemParts.maxItemsToReturn =
            conversationItemParts.maxItemsToReturn + LOAD_MORE_INCREMENT;
        conversationItemParts.syncState = '';
        // Calculate how many times the user has clicked "loadMore" for this conversation.
        var dataPoint = returnTopExecutingActionDatapoint();
        if (dataPoint) {
            // Null check for tests.
            dataPoint.addCustomData([
                getLoadMoreIteration(conversationItemParts.maxItemsToReturn),
            ]);
        }
        return loadConversation(conversationId);
    }
    return Promise.resolve();
}));
function getLoadMoreIteration(maxItemsToReturn) {
    // Ex: maxItemsToReturn = 40. (40-20)/10 = 2. This is the second time the user has clicked load more.
    // The ceil function should be unnecessary. It's a precaution so future changes don't put us over the 24 unique value count mentioned below.
    var iteration = Math.ceil((maxItemsToReturn - 20) / 10);
    // For datapoint aggregation in azure we can only have 24 unique possible values for any custom data key.
    // Accounting for 0, bucket all values >=23 as "23".
    return iteration >= 23 ? 23 : iteration;
}
//# sourceMappingURL=loadMore.js.map